import { render, staticRenderFns } from "./ReadonlyBlock.vue?vue&type=template&id=69af5bf0&scoped=true"
import script from "./ReadonlyBlock.vue?vue&type=script&lang=js"
export * from "./ReadonlyBlock.vue?vue&type=script&lang=js"
import style0 from "./ReadonlyBlock.vue?vue&type=style&index=0&id=69af5bf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69af5bf0",
  null
  
)

export default component.exports